// extracted by mini-css-extract-plugin
export default {"errorMessage":"MyTextArea_errorMessage__Gw638"};